import { render, staticRenderFns } from "./SupplierModal.vue?vue&type=template&id=350b1398&scoped=true"
import script from "./SupplierModal.vue?vue&type=script&lang=js"
export * from "./SupplierModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierModal.vue?vue&type=style&index=0&id=350b1398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b1398",
  null
  
)

export default component.exports